
<script>
	import listBase from '@_system/components/base/list.vue'
	import detailIndex from './detail/index.vue'
	export default {
		extends: listBase,
		name: 'clickfarmIndex',
		props: {

		},
		render(h) {
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<detail-index list={this} ref="contractdetail" row={this.currentrow} />
				</div>
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'clickfarm',
				windowName: '客服账台',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			cellClick({row}) {			
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.contractdetail.getdetail()
				})
			},
		},
		components: {
			detailIndex
		}
	}
</script>
